<script>
import Layout from "../../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { incomeCategoryService } from "../../../../../services/managements/incomes/incomecategory.service";

import List from "../../../../../components/list";
import Screen from "../../../../../components/screen";
import i18n from "../../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
    extends:Screen,
    page: {
        title: "Income Category List",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader, List },
    data() {
        return {
        data: {},
        typeList: {},
        fetchingStats: false,
        title: "Income Category List",

        };
    },
    mounted() {
        this.loadingData();
    },

    methods: {
        loadingData: function(param = '') {
            this.fetchingStats = false;
            incomeCategoryService.getList(param)
                .then(response => {
                
                this.fetchingStats = true;
                this.data = response;
                // console.log(this.data)
            });
        },


        deleted: function(id) {
        incomeCategoryService.remove(id)
            .then(response => {
            if(response.status == 200) {
                this.$swal.fire({
                title: i18n.t('general.confirm.deleted'),
                text: i18n.t('general.confirm.success'),
                icon: "success",
                confirmButtonText: i18n.t('general.ok')
                });
            }
            });
        },

        pageNavigate: function(param) {
            this.loadingData(param);
        },

        submitAdd: function() {
        this.$router.push(this.$route.query.redirectFrom || {
                name: "manage-income-category-add",
            });
        },

    }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'manage-income-category-add'}" :title="$t('manage.income-category.text')" />
    <div v-if="data">
        <List v-bind:dataList="data" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ 
            `name: ${$t('manage.income-category.name')}`,
            `name_en: ${$t('manage.name_en')}`,
          ]"
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'manage-income-category-edit'}"
          v-bind:filter="{
            search: ['manage_income_categories.name','manage_income_categories.name_en'],
          }"
          
    />      
    </div>
  </Layout>
</template>